<template>
  <div
    class="flex flex-col items-center"
  >
    <img
      class="text-center"
      :src="require('@/assets/images/no-templates.svg')"
      alt="No templates"
    />
    <p class="font-bold mt-1 text-base text-center">
      {{ $i18nPresenter.t("Can't fetch templates!") }}
    </p>
    <p class="text-sm text-base-90 text-center">
      {{ `${$i18nPresenter.t("Something went wrong.")} ${$i18nPresenter.t("Please")} ` }}
      <a class="text-link font-bold text-primary-90" @click="reload()">
        {{ $i18nPresenter.t("reload") }}
      </a>{{ ` ${$i18nPresenter.t("your browser.")}` }}
    </p>
  </div>
</template>

<script>
export default {
  methods: {
    reload() {
      window.location.reload()
    },
  },
}
</script>
